import { useEffect, useState } from "react";
import { getLifecycleDashboard, exportExitReport } from "./lifecycleApi";
import { downloadBlob } from "../Employees/employeeFileUtils";
import BrixigoPageLoader from "../../components/common/BrixigoPageLoader";
import { Download } from "lucide-react";

export default function LcExitAnalytics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLifecycleDashboard().then(setData).finally(() => setLoading(false));
  }, []);

  if (loading) return <BrixigoPageLoader compact message="Loading analytics…" />;

  const off = data?.offboarding?.by_status || {};
  const wf = data?.workforce || {};
  const entries = Object.entries(off);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">Exit Analytics</h2>
        <button
          type="button"
          onClick={async () => downloadBlob(await exportExitReport(), "attrition_report.csv")}
          className="inline-flex items-center gap-1 px-3 py-2 rounded-lg border text-sm"
        >
          <Download className="w-4 h-4" /> Export Report
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="rounded-xl border p-5" style={{ background: "var(--bg-surface, #fff)" }}>
          <p className="text-sm text-slate-500">Attrition Rate</p>
          <p className="text-4xl font-bold text-red-600 mt-1">{wf.attrition_rate}%</p>
        </div>
        <div className="rounded-xl border p-5" style={{ background: "var(--bg-surface, #fff)" }}>
          <p className="text-sm text-slate-500">Exited This Year</p>
          <p className="text-4xl font-bold mt-1">{wf.exited_this_year}</p>
        </div>
        <div className="rounded-xl border p-5" style={{ background: "var(--bg-surface, #fff)" }}>
          <p className="text-sm text-slate-500">F&amp;F Pending</p>
          <p className="text-4xl font-bold text-purple-600 mt-1">{data?.offboarding?.fnf_pending || 0}</p>
        </div>
      </div>

      <div className="rounded-xl border p-4" style={{ background: "var(--bg-surface, #fff)" }}>
        <h3 className="font-medium mb-4">Offboarding by Status</h3>
        <div className="space-y-3">
          {entries.length ? entries.map(([status, count]) => (
            <div key={status}>
              <div className="flex justify-between text-sm mb-1">
                <span>{status}</span>
                <span className="font-medium">{count}</span>
              </div>
              <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-violet-500 rounded-full"
                  style={{ width: `${Math.min(100, (count / Math.max(...entries.map(([, c]) => c), 1)) * 100)}%` }}
                />
              </div>
            </div>
          )) : <p className="text-slate-500 text-sm">No offboarding data yet</p>}
        </div>
      </div>
    </div>
  );
}
